import { Grid } from '@mui/material';

import BaggageInfo from '@FlightsComponents/BaggageInfo';
import Salida from '@shared/assets/logos/salida';
import FlightItineraryHeader from '@shared/pages/Flights/components/FlightItinerary/FlightItineraryHeader';

import FlightSegment from './FlightSegment';
import HorizontalSeparator from '@FlightsComponents/HorizontalSeparator';
import FlightItineraryLine from './FlightItineraryLine';

const Separator = ({ id }) => <HorizontalSeparator id={id} color="#E5E5E5" />;

const FlightSegmentList = ({ firstAirport, lastAirport, option }) => (
  <>
    <FlightSegment
      icon={<Salida />}
      date={option.departure}
      origin={option.origin_airport}
      airport={firstAirport[1] || firstAirport[0]}
    />
    <FlightSegment
      icon={<Salida />}
      date={option.arrival}
      origin={option.destination_airport}
      airport={lastAirport[1] || lastAirport[0]}
    />
  </>
);

const FlightItineraryBlock = ({
  option,
  firstFlight,
  firstAirport,
  lastAirport,
  cluster,
  index,
}) => {
  return (
    <Grid
      container
      direction="column"
      key={option.hash + '-itinerary'}
      id={'itinerary-' + option.hash}
      sx={{ textAlign: 'center', mt: 2 }}
    >
      <FlightItineraryHeader
        option={option}
        cluster={cluster}
        leg={cluster.legs[index]}
        firstFlight={firstFlight}
      />

      <Separator id={`SEPARATORSUP-${index}`} />

      <FlightItineraryLine option={option} />

      <FlightSegmentList
        firstAirport={firstAirport}
        lastAirport={lastAirport}
        option={option}
      />

      <BaggageInfo baggage={option.flight_baggage} baggageIsRow />

      <Separator id={`SEPARATORINF-${index}`} />
    </Grid>
  );
};

export default FlightItineraryBlock;
